import useEVMCore from '~/composables/web3/EVM/useEVMCore';
import type { ConfigsProvider, ProviderConfig } from '~/service/config';

/**
 * @description Хук для получения конфигурации провайдера.
 *
 * @param provider - Название провайдера (по умолчанию 'evm')
 * @returns Функция, которая принимает массив ключей и возвращает объект с нужными полями конфигурации.
 */
export default function useProviderConfig<P extends keyof ConfigsProvider>(provider: P = 'evm' as P) {
    const evmCore = useEVMCore();

    if (!evmCore) {
        throw new Error('[useProviderConfig] CoreServices не найден в Nuxt Plugin.');
    }

    return <K extends keyof ProviderConfig<P>>(keys: K[]): Pick<ProviderConfig<P>, K> => {
        return evmCore.configs.getConfigFields<P, K>(provider, keys);
    };
}
